import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { veiculoService } from '@/services/veiculo.service'
import type { Veiculo } from '@/types/database'
import type { ListFilters } from '@/services/associado.service'

export function useVeiculos(filters: ListFilters & { associado_id?: string } = {}) {
    return useQuery({
        queryKey: ['veiculos', filters],
        queryFn: () => veiculoService.list(filters),
    })
}

export function useVeiculo(id: string | null) {
    return useQuery({
        queryKey: ['veiculo', id],
        queryFn: () => veiculoService.getById(id!),
        enabled: !!id,
    })
}

export function useCreateVeiculo() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (input: Partial<Veiculo>) => veiculoService.create(input),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['veiculos'] }),
    })
}

export function useUpdateVeiculo() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: ({ id, ...input }: Partial<Veiculo> & { id: string }) => veiculoService.update(id, input),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['veiculos'] })
            qc.invalidateQueries({ queryKey: ['veiculo'] })
        },
    })
}

export function useDeleteVeiculo() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => veiculoService.remove(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['veiculos'] }),
    })
}
